import { api } from '../lib/api-client';

export const biodataApi = {
  getBioData: ({ employer_number, staff_number }) =>
    api.get('biodata', { params: { employer_number, staff_number } }),
};

export default biodataApi;
